import React from "react";
import { Mail, Phone } from "lucide-react";
import { FaLinkedin } from "react-icons/fa6";
import { FiInstagram } from "react-icons/fi";
import { FaFacebookSquare } from "react-icons/fa";
import { RiTwitterXFill } from "react-icons/ri";
import { IoLogoYoutube } from "react-icons/io";
import { FcGoogle } from "react-icons/fc";


import mhcGlobalLogo from "../assets/mhc-logo.png";

export default function FooterSection() {
  return (
    <footer className="w-full bg-black text-white">
      <div className="max-w-[1920px] mx-auto px-6 sm:px-10 lg:px-[54px] py-14">

        {/* TOP AREA */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-6 items-start">

          {/* LEFT SIDE */}
          <div>

            {/* CONTACT */}
            <div className="space-y-2">

              <div className="mb-6">
                <img
                  src={mhcGlobalLogo}
                  alt="MHC Global"
                  className="w-[160px] sm:w-[200px] object-contain"
                  draggable="false"
                />
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <Mail size={16} />
                <a
                  href="mailto:info@mhcglobal.info"
                  className="text-[16px] sm:text-[18px] lg:text-[20px] hover:text-white transition"
                >
                  info@mhcglobal.info
                </a>
              </div>

              <div className="flex items-center gap-3 text-white/70">
                <Phone size={16} />
                <span className="text-[16px] sm:text-[18px] lg:text-[20px]">
                  +91 7305952831
                </span>

                <span className="text-[18px] text-white/70">|</span>

                <span className="text-[16px] sm:text-[18px] lg:text-[20px]">
                  +91 9884807480
                </span>
              </div>
            </div>

            {/* SOCIAL ICONS */}
            <div className="mt-6 flex items-center gap-4">

              {/* LINKEDIN */}
              <a href="//www.linkedin.com/company/mhcockpit/">
                <div className="w-9 h-9 rounded-[6px] bg-[#0A66C2] flex items-center justify-center">
                  <FaLinkedin className="text-white text-[18px]" />
                </div>
              </a>

              {/* INSTAGRAM */}
              <a href="//www.instagram.com/mh_cockpit/">
                <div className="w-9 h-9 rounded-[8px] bg-gradient-to-br from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] flex items-center justify-center">
                  <FiInstagram className="text-white text-[18px]" />

                </div>
              </a>

              {/* FACEBOOK */}
              <a href="//www.facebook.com/MHCockpitAviationAcademy/">
                <div className="w-9 h-9 rounded-[6px] bg-[#1877F2] flex items-center justify-center text-white text-[18px] font-bold">
                  <FaFacebookSquare className="text-white text-[18px]" />
                </div>
              </a>

              {/* X */}
              <a href="//x.com/account/access">
                <div className="w-9 h-9 rounded-[6px] bg-white flex items-center justify-center text-black text-[18px] font-medium">
                  <RiTwitterXFill className="text-black text-[18px]" />
                </div>
              </a>

              {/* YOUTUBE */}
              <a href="//www.youtube.com/@mhcockpit">
                <div className="w-9 h-9 rounded-[8px] bg-[#FF0000] flex items-center justify-center">
                  <IoLogoYoutube className="text-white text-[18px]" />
                </div>
              </a>

              {/* GOOGLE */}
              <a href="/">
                <span className="text-[26px] font-semibold bg-gradient-to-r from-[#4285F4] via-[#FBBC05] to-[#34A853] text-transparent bg-clip-text">
                  <FcGoogle className="text-white text-[38px]" />
                </span>
              </a>

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="lg:justify-self-end">
            <p className="text-[14px] sm:text-[16px] lg:text-[18px] text-white/70">
              © {new Date().getFullYear()} MHC Global. All rights reserved.
            </p>

            <div className="mt-4 space-y-2">
              {/* <a
                href="//mhcognition.com/refund-policy"
                className="block text-[14px] sm:text-[16px] lg:text-[18px] text-white/70 underline underline-offset-4 hover:text-white"
              >
                Refund Policy
              </a> */}

              <a
                href="/privacy-policy"
                className="block text-[14px] sm:text-[16px] lg:text-[18px] text-white/70 underline underline-offset-4 hover:text-white"
              >
                Privacy Policy
              </a>

              <a
                href="/terms-and-conditions"
                className="block text-[14px] sm:text-[16px] lg:text-[18px] text-white/70 underline underline-offset-4 hover:text-white"
              >
                Terms and Conditions
              </a>
            </div>
          </div>
        </div>

        {/* DESCRIPTION */}
        <div className="mt-10 max-w-[950px]">
          <p className="text-white/45 text-[16px] sm:text-[18px] lg:text-[20px] leading-[1.5]">
            At MH Cockpit, we seamlessly integrate Artificial Intelligence and
            Robotics into our training division, dedicated to imparting
            unparalleled knowledge to the next generation of aviators and
            enthusiasts in AI & Robotics.
          </p>
        </div>

        {/* DIVIDER */}
        {/* <div className="mt-10 border-t border-white/15" /> */}

        {/* BOTTOM BIG LOGO */}
        {/* <div className="pt-6 flex justify-center">
          <img
            src={mhcGlobalLogo}
            alt="MHC Global"
            className="w-full max-w-[900px] object-contain opacity-[0.15]"
            draggable="false"
          />
        </div> */}

      </div>
    </footer>
  );
}